import { ELEMENT_GROUPS } from '../../../../AppDesigner/Elements';

const fields = {
  group: ELEMENT_GROUPS.TEXT,
  name: 'MarketTraderDashboard',
  label: 'Market Trader Dashboard',
  icon: 'DocumentTextIcon',
  description: 'Displays a dashboard for oanda automated trading',
  properties: []
};

export default fields;
